export default __webpack_public_path__ + "static/media/semolino.5fb635b8.jpg";